import { render, staticRenderFns } from "./Elemento.vue?vue&type=template&id=489b9cf9&scoped=true&"
import script from "./Elemento.vue?vue&type=script&lang=js&"
export * from "./Elemento.vue?vue&type=script&lang=js&"
import style0 from "./Elemento.vue?vue&type=style&index=0&id=489b9cf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b9cf9",
  null
  
)

export default component.exports